import { render } from "./FrotaAlertasPorGrupoChart.vue?vue&type=template&id=3c9df071&scoped=true"
import script from "./FrotaAlertasPorGrupoChart.vue?vue&type=script&lang=js"
export * from "./FrotaAlertasPorGrupoChart.vue?vue&type=script&lang=js"

import "./FrotaAlertasPorGrupoChart.vue?vue&type=style&index=0&id=3c9df071&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9df071"]])

export default __exports__